import type {
  ConversationChatbotMessageAddedEvent,
  ConversationFacebookMessengerMessageAddedEvent,
  ConversationMessengerMessageAddedEvent,
  ConversationTwitterMessageAddedEvent,
  ConversationWhatsAppMessageAddedEvent,
  ConversationWidgetChatMessageAddedEvent,
} from 'lib-shared-types-api';
import { ComponentProps } from 'react';

import { ConversationEventGroupConfigBase } from 'components/conversation/conversationEventGroups/conversationEventGroups.types';

import { ConversationTextualMessage } from '../../textualMessage/conversationTextualMessage';
import { ConversationTextualMessagePropBase } from '../../textualMessage/conversationTextualMessage.types';

/** Represents the conversation email event group configuration. */
export type ConversationTextualEventGroupConfig =
  ConversationEventGroupConfigBase<
    | 'group:adachat'
    | 'group:digitalgeniuschat'
    | 'group:kindlychat'
    | 'group:facebook_messenger'
    | 'group:whats_app'
    | 'group:widget_chat'
    | 'group:messenger'
    | 'group:sms'
    | 'group:twitter',
    Pick<
      ConversationTextualEventGroupProps,
      'hideAttachments' | 'hideGutterActions'
    >
  >;

type ConversationTextualEventGroupProps = ConversationTextualMessagePropBase<
  | ConversationChatbotMessageAddedEvent
  | ConversationFacebookMessengerMessageAddedEvent
  | ConversationMessengerMessageAddedEvent
  | ConversationWhatsAppMessageAddedEvent
  | ConversationWidgetChatMessageAddedEvent
  | ConversationTwitterMessageAddedEvent,
  Pick<
    ComponentProps<typeof ConversationTextualMessage.Events>,
    'hideAttachments'
  >
>;

/** Represents the component for displaying a conversation textual event group. */
export const ConversationTextualEventGroup = ({
  author,
  className,
  events,
  hideAttachments,
  hideGutterActions,
}: ConversationTextualEventGroupProps): JSX.Element => {
  const timestamp = events[events.length - 1].created_at;

  return (
    <ConversationTextualMessage
      className={className}
      author={author}
      timestamp={timestamp}
      hideGutterActions={hideGutterActions}
      variant={
        events[0].direction === 'outbound'
          ? 'textualOutbound'
          : 'textualInbound'
      }
    >
      <ConversationTextualMessage.Events
        events={events}
        hideAttachments={hideAttachments}
      />
    </ConversationTextualMessage>
  );
};
